export const FullsizePage = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className="flex size-full flex-col overflow-y-auto">{children}</div>
  );
};
